import React from 'react';
import { Alert, Button } from '@mui/joy';

/** Failed requests are actionable, never disguised as an empty queue. */
export function AdminQueryError({
  error,
  retry,
  message = 'This information could not be loaded.',
}: {
  error: unknown;
  retry: () => unknown;
  message?: string;
}) {
  if (!error) return null;
  return (
    <Alert
      color="danger"
      role="alert"
      endDecorator={
        <Button size="sm" variant="soft" color="danger" onClick={() => retry()}>
          Retry
        </Button>
      }
    >
      {message}
    </Alert>
  );
}
